<template>

    <div class="text-sm">

        <!-- <div class="flex items-center font-bold">
            <vue-feather type="globe" class="h-5 w-5 mr-2"></vue-feather> <span>Data Center location for recording files</span>
        </div> -->

        <!-- <div class="flex mt-10"> -->
        <div class="flex flex-row flex-grow">
            <div class="flex flex-grow">
                <div class="flex flex-grow font-medium text-sm">
                    Data Center location - <docs-link
                        href="https://docs.birdie.so/birdie-docs/security/storage-location" />
                </div>
                <div class="flex mr-1">
                    <jet-dropdown align="right" width="80" :class="[bucket ? 'pointer-events-none' : '', 'flex']"
                        style="margin-top:-1px">
                        <template #trigger>
                            <span class="inline-flex rounded-md">
                                <button type="button"
                                    class="inline-flex items-center px-2 py-0 border border-transparent focus:outline-none">

                                    <span class="text-blue-500 font-bold">
                                        {{ selectedLocation.name }}
                                    </span>

                                    <svg v-if="!bucket" class="ml-2 -mr-0.5 h-4 w-4 text-blue-500"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd"
                                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </span>
                        </template>

                        <template #content class="w-56 ">
                            <a href="#" v-for="location in locations"
                                :key="'location_' + location.id + '_' + changeBucketCount"
                                class="px-4 py-2 leading-5 text-gray-700 transition rounded flex flex-row hover:bg-gray-100"
                                :class="{ 'text-blue-500 font-bold': location.id == selectedLocation.id }"
                                @click.prevent="changeBucket(location.id)">
                                <span class="flex flex-grow">{{ location.name }}</span>
                                <vue-feather v-if="location.id == selectedLocation.id" type="check"
                                    class="w-4 h-4 ml-2 self-center"></vue-feather>
                            </a>
                        </template>
                    </jet-dropdown>
                </div>
            </div>

            <div class="flex items-center" v-if="bucket">
                <span class="text-sm text-gray-400">Need to change? <a href="#" @click.prevent="openChat"
                        title="Ask for data-center location change"
                        class="text-blue-500 hover:text-blue-600 hover:underline">ask
                        us</a>
                </span>
            </div>

        </div>
        <!-- </div> -->

    </div>

</template>

<script>

import Toggle from '@/Components/UI/Toggle'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import JetDropdown from '@/Jetstream/Dropdown'

export default {

    props: ["plan_custom_s3_bucket", "bucket", "birdie_buckets"],

    components: {
        Toggle, JetSectionBorder, JetDropdown
    },

    created: function () {

        // var team_location = null

        if (this.birdie_buckets) {
            for (var i = 0; i < this.birdie_buckets.length; i++) {
                this.locations.push({ id: this.birdie_buckets[i].id, name: this.birdie_buckets[i].birdie_shared_name })
                if (this.$page.props.user.current_team.drive_id == this.birdie_buckets[i].id) {
                    //team_location = this.birdie_buckets[i].birdie_shared_name
                    //break
                    this.selectedLocation = this.locations[i]
                }
            }
        }

        //console.log("team_location", team_location)

        //let team_location = this.$page.props.user.current_team.server_location

        if (this.plan_custom_s3_bucket) {
            if (this.bucket) {
                this.locations.push({ id: 's3_custom', name: this.bucket })
                this.selectedLocation = this.locations[this.locations.length - 1]
            } else {
                this.locations.push({ id: 's3_new', name: 'Your S3 bucket (ask us)' })
            }
        } else {
            this.locations.push({ id: 's3_disabled', name: 'Your S3 bucket (Business plan)' })
        }
        // if (this.plan_custom_s3_bucket && this.bucket) {
        //     this.selectedLocation = this.locations[2]
        // } else if (team_location) {
        //     if (team_location != "us") {
        //         for (var i=0; i<this.locations.length; i++) {
        //             if (this.locations[i].code == team_location) {
        //                 this.selectedLocation = this.locations[i]
        //                 break
        //             }
        //         }
        //     }
        // }
        // console.log("locations", this.locations)
    },

    data() {
        return {
            locations: [
                // {code: 'us', name: 'US'},
                // {code: 'eu', name: 'Europe'}
            ],
            selectedLocation: null, //{code: 'us', name: 'US'},
            canChangeFeature: false,
            saving: false,
            changeBucketCount: 0
        }
    },

    mounted: function () {
    },

    methods: {
        changeBucket(locationId) {
            if (this.saving) return
            if (locationId == 's3_custom' || locationId == 's3_new') {
                this.openChat()
            } else if (locationId == 's3_disabled') {
                // navigate to route subscription.index
                this.$inertia.visit(route('subscription.index'))
            } else if (locationId != this.selectedLocation.id) {
                this.saving = true
                let url = this.$page.props.api_url + '/v1/team/update';
                axios.post(url, {
                    bucket_id: locationId
                })
                    .then(response => {
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("Setting updated", options)
                        this.changeBucketCount++
                        this.selectedLocation = this.locations.find(location => location.id == locationId)
                        this.saving = false
                    })
                    .catch(e => {
                        console.error(e);
                        const errorMessage = typeof e.response.data === 'string'
                            ? e.response.data
                            : e.response.data.message || 'An unknown error occurred';
                        let options = {
                            type: "danger",
                            timeout: 10000,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("An error occurred:" + errorMessage, options)
                        this.saving = false
                    });
            }
        },
        openChat() {
            if (typeof Intercom === "function") {
                Intercom('show')
            }
        },
    },

    computed: {

    }
}


</script>

<style scoped></style>
